import { Star } from "lucide-react";

// Shared 5-star rating input — extracted from the duplicated rubric-row
// implementations in PeerReview.jsx and the old Dashboard feedback widget.
export default function StarRating({ value, onChange, testIdPrefix = "star-rating", size = "w-9 h-9" }) {
  return (
    <div className="flex items-center gap-1" data-testid={testIdPrefix}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          data-testid={`${testIdPrefix}-${n}`}
          onClick={() => onChange(n)}
          className={`${size} rounded-lg grid place-items-center transition ${
            n <= value ? "bg-[#D97706] text-white" : "bg-white border border-[#E7E0D2] text-[#9CA3AF] hover:border-[#D97706] hover:text-[#D97706]"
          }`}>
          <Star className="w-4 h-4" fill={n <= value ? "currentColor" : "none"} />
        </button>
      ))}
    </div>
  );
}
